import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubResultView]'})
export class ResultViewDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
